import MojolockBase from './mojolock_base';

class MojoknobBlack extends MojolockBase  {
  #price;

  constructor(account) {
    super();
    this.#price = account.mojoknob_black_unit_price / 100;
  }

  // Show price for monthly payment plan in case of 36 months selected
  formatPriceForShopfront(price) {
    return (price / 36).toFixed(2);
  }

  getPrice() {
    return this.#price;
  }
}

export default MojoknobBlack;
